import React from "react";

/**
 * Componente ToggleSwitch reutilizable
 * 
 * @param {Object} props
 * @param {boolean} props.enabled - Estado del switch (encendido/apagado)
 * @param {Function} props.onChange - Función que se ejecuta al cambiar el estado
 * @param {string} props.label - Etiqueta del switch
 * @param {string} props.description - Descripción adicional (opcional)
 */
const ToggleSwitch = ({ enabled, onChange, label, description }) => {
  return (
    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border-2 border-gray-200 hover:border-blue-300 transition-colors">
      <div className="flex-1">
        <label className="block text-sm font-semibold text-gray-700 mb-1 cursor-pointer">
          {label}
        </label>
        {description && (
          <p className="text-xs text-gray-500">{description}</p>
        )}
      </div>
      <button
        type="button"
        onClick={() => onChange(!enabled)}
        className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          enabled ? "bg-blue-600" : "bg-gray-300"
        }`}
        aria-label={label}
        aria-pressed={enabled}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-transform ${
            enabled ? "translate-x-8" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};

export default ToggleSwitch;
